import 'typings.d';

export const environment = {
  firebase: window.env.firebaseClientConfig,
  production: true,
  wagerApi: window.env.wagerApi,
  walletApi: window.env.walletApi,
  build: 8,
  version: '1.0.7',
  deployment: window.env.deployment,
};
